import mod from "-!./Authentication.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Authentication.js?vue&type=script&lang=js&"